import matchUserAgentWithRegExp from './matchUserAgentWithRegExp';

export default userAgentParam => matchUserAgentWithRegExp(userAgentParam, /iPhone|iPod/, !window.MSStream);
